import * as React from "react";
import { ModalConfirmation } from "@adsk/alloy-react-modal";
import { useTranslations } from "@adsk/acc-issues-translations";
import { useCallback } from "react";

export const DiscardModal = ({
  isOpen = false,
  onDiscard,
  closeDiscardModal,
  onDiscardConfirm,
  onDiscardAbort,
}: {
  isOpen?: boolean;
  onDiscard: () => void;
  closeDiscardModal: () => void;
  onDiscardConfirm?: () => void;
  onDiscardAbort?: () => void;
}) => {
  const { T } = useTranslations();
  const handleConfirm = useCallback(() => {
    onDiscardConfirm?.();
    onDiscard();
  }, [onDiscard, onDiscardConfirm]);

  const handleClose = useCallback(() => {
    onDiscardAbort?.();
    closeDiscardModal();
  }, [closeDiscardModal, onDiscardAbort]);

  return (
    <ModalConfirmation
      style={{}}
      show={isOpen}
      onConfirm={handleConfirm}
      onClose={handleClose}
      title={T.translate("discardModal.title") as string}
      message={T.translate("thisActionCantBeUndone")}
      confirmationButtonLabel={T.translate("actions.discard") as string}
    />
  );
};
